module.exports = __webpack_public_path__ + "img/wp3.f336ebaa.jpeg";